import ExtractState from "../../../models/ExtractState"
import * as ActionTypes from "./types"
import { toast } from "react-toastify"

const initialExtract: ExtractState = {
	downloadInProgress: false,
	sendToSftpInProgress: false
}

function consultantMonthlyPatientScoreExtractReducer(
	state = initialExtract,
	action: any
) {
	switch (action.type) {
		case ActionTypes.CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_REQUEST:
			return {
				...state,
				sendToSftpInProgress: true
			}
		case ActionTypes.CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_RECEIVE:
			toast.success("Sending to SFTP. Check Slack for progress")
			return {
				...state,
				sendToSftpInProgress: false
			}
		case ActionTypes.CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_FAILURE:
			toast.error(
				"Unable to send Consultant Monthly Patient Score extract to SFTP"
			)
			return {
				...state,
				sendToSftpInProgress: false
			}
	}
	return state
}

export default consultantMonthlyPatientScoreExtractReducer
